module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/top/banner03-c8fe8ddaf3d0d730bc479507c4e82d03.png";